define([

    ], function () {

    const debounce = (func, delay) => {
        let inDebounce;
        return function() {
            const context = this;
            const args = arguments;
            clearTimeout(inDebounce);
            inDebounce = setTimeout(() => func.apply(context, args), delay);
        }
    };

    return function initSearchField(DOMEl, cb, data) {

            var payload = data.next;

            DOMEl.searchField.value = payload;
            DOMEl.searchField.classList.add('active');
            if (payload) {
                DOMEl.searchField.classList.add('active');
            }

            document.addEventListener('click', function (event) {
                var isClickInside = DOMEl.wrap.contains(event.target);
                if (!isClickInside && !payload) {
                    // DOMEl.searchField.classList.remove('active');
                }
            });

            DOMEl.openBtn.addEventListener("click", function (e) {
                if(DOMEl.searchField.value !== ""){
                    payload = validate(DOMEl.searchField.value);
                    cb(payload);
                }
            });
            DOMEl.resetBtn.style.display = "none";
            DOMEl.resetBtn.addEventListener("click", function (e) {
                DOMEl.resetBtn.style.display = "none";
                DOMEl.searchField.value = "";
                payload = "";
                cb("");
            });

            // for fetching instant results while typing
            // let onInputCB =  debounce(function (payload) {
            //     cb(payload);
            // }, 1000);

            DOMEl.searchField.addEventListener("keyup", (e) => {

                // don't re-submmit if value hasn't changed
                if(e.target.value === payload) {
                    return;
                }
                
                if(e.target.value) {
                    DOMEl.resetBtn.style.display = "block";
                } else {
                    // reset results when user manually clears input
                    DOMEl.resetBtn.style.display = "none";
                    payload = "";
                    cb("");
                }
                
                // search on enter key
                if(e.keyCode == 13){
                    payload = validate(e.target.value);
                    cb(payload);
                }

                //onInputCB(payload);
            } );

            function validate(value) {

                value = value.trim();
                var l = value.length;
                //max chars
                if (Number.isInteger(value * 1)) {
                    return value;
                }
                if (l >= 0) {
                    return value;
                }
                    return "";

            }

            return {
                resetBtn: DOMEl.resetBtn,
                reset: function () {
                    DOMEl.searchField.value = "";                    
                    payload = "";
                }
            }
        }
});
